export class Segment {
	Id: number;
	Name: string;
	EnforceSingleParent: boolean;
	CreatedOn: Date;
	CreatedByUserId: number;
	ModifiedOn: Date;
	ModifiedByUserId: number;
	ReviewedOn: Date;
	ReviewedByUserId: number;
	Active: boolean;
}
